module.exports = __webpack_public_path__ + "img/统计报表-小标题@2x.e2560833.png";